import {MI} from "../init";
import AbstractSymbol from "./AbstractSymbol";
import SymbolPestle from "./SymbolPestle";
import SymbolRing from "./SymbolRing";
import SymbolCrystal from "./SymbolCrystal";
import SymbolGold from "./SymbolGold";
import SymbolCandle from "./SymbolCandle";
import SymbolAlchemist from "./SymbolAlchemist";
import SymbolBook from "./SymbolBook";
import SymbolFlask from "./SymbolFlask";

/**
 * @constructor
 * @returns {SymbolsManager}
 */
export default function SymbolsManager() {

    /** @type {SpinReels} */
    this._spinReels;
};

SymbolsManager.prototype = {

    /**
     * @param {SpinReels} spinReels
     * @returns {undefined}
     */
    init: function(spinReels) {
        this._spinReels = spinReels;
    },

    getSymbolData: function(symbol) {
        return {
            'spriteName': symbol.getSprite().getName(),
            'symbolNum': symbol.getSymbolNum(),
            'symbolName': symbol.getSymbolName(),
            'px': symbol.getPosX(),
            'py': symbol.getPosY(),
            'rx': symbol.getReelX(),
            'ry': symbol.getReelY(),
            'spreaded': symbol.spreaded
        };
    },

    /**
     * @param {*} id
     * @returns {boolean}
     */
    _isNumber: function (id) {
        return !isNaN(id);
    },

    /**
     * @param {string|number|null} symbolId
     * @param {number} x
     * @param {number} y
     * @param {number=} reelX
     * @param {number=} reelY
     * @param {string=} name
     * @returns {AbstractSymbol}
     */
    create: function(symbolId, x, y, reelX, reelY, name) {

        reelX = typeof reelX !== 'undefined' ? reelX : -1;
        reelY = typeof reelY !== 'undefined' ? reelY : -1;

        var symbolName = "";
        var symbolNum = 0;

        if(this._isNumber(symbolId)) {
            symbolNum = symbolId * 1;
            symbolName = AbstractSymbol.getSymbolByNum(symbolNum);
        } else {
            symbolName = (symbolId).toString();
            symbolNum = AbstractSymbol.getNumBySymbolName(symbolName);
        }

        var sprite = MI.addImg(x, y, "symbols_atlas", name);

        switch(symbolName) {
            case "symbol_Pestle":
                return new SymbolPestle(sprite, symbolNum, reelX, reelY);
            case "symbol_Ring":
                return new SymbolRing(sprite, symbolNum, reelX, reelY);
            case "symbol_Crystal_blue":
            case "symbol_Crystal_red":
                return new SymbolCrystal(sprite, symbolNum, reelX, reelY);
            case "symbol_Gold":
                return new SymbolGold(sprite, symbolNum, reelX, reelY);
            case "symbol_Candle":
                return new SymbolCandle(sprite, symbolNum, reelX, reelY);
            case "symbol_Alchemist":
                return new SymbolAlchemist(sprite, symbolNum, reelX, reelY);
            case "symbol_Book":
                return new SymbolBook(sprite, symbolNum, reelX, reelY);
            case "symbol_A":
            case "symbol_J":
            case "symbol_K":
            case "symbol_Q":
                return new SymbolFlask(sprite, symbolNum, reelX, reelY);
        }

        throw new Error("no symbol found");
    },

    /**
     * @param {AbstractSymbol} symbol
     * @param {string|number=} symbolId
     * @param {string=} spriteName
     * @returns {AbstractSymbol}
     */
    createFromSymbol: function(symbol, symbolId, spriteName) {

        var symbolData = this.getSymbolData(symbol);
        var sid = typeof symbolId !== 'undefined' ? symbolId : symbolData["symbolNum"];

        return this.create(
            sid,
            symbolData['px'],
            symbolData['py'],
            symbolData['rx'],
            symbolData['ry'],
            spriteName
        );
    },

    showHideSymbol: function(symbol) {

        if(!symbol) {
            return;
        }

        if(this.isHideable(symbol)) {
            symbol.setVisible(false);
        } else {
            symbol.setVisible(true);
        }
    },

    /**
     * @param {AbstractSymbol} symbol
     * @returns {boolean}
     */
    isHideable: function(symbol) {
        return (this._spinReels.isInSpread(symbol) && !symbol.spreaded);
    }
};